var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPopover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 165,
  height: 86,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 160,
  height: 82.95,
  x: 4.036,
  y: 2.942,
  fill: "var(--hop-neutral-border-strong)",
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 79,
  x: 1,
  y: 1.108,
  fill: "var(--hop-neutral-surface)",
  rx: 7
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 79,
  x: 1,
  y: 1.108,
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 4,
  x: 13.559,
  y: 17.462,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 122.506,
  height: 4,
  x: 13.559,
  y: 41.462,
  fill: "#CCCCCA",
  rx: 2
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 108,
  height: 4,
  x: 13.559,
  y: 57.462,
  fill: "#CCCCCA",
  rx: 2
})));
export default SvgPopover;